import { render, staticRenderFns } from "./RecordCut.vue?vue&type=template&id=6f20509d"
import script from "./RecordCut.vue?vue&type=script&lang=js"
export * from "./RecordCut.vue?vue&type=script&lang=js"
import style0 from "./RecordCut.vue?vue&type=style&index=0&id=6f20509d&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports